import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs/operators';

export const authGuard = () => {
  const oidcSecurityService = inject(OidcSecurityService);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        // Store the current URL with query params before redirecting to login
        const currentUrl = window.location.href;
        sessionStorage.setItem('auth_redirect_url', currentUrl);
        oidcSecurityService.authorize();
        return false;
      }
      return true;
    }),
  );
};
